import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import EntryGuide from "./components/EntryGuide";
import Features from "./components/Features";
import CategoryComics from "./components/CategoryComics";
import Comparison from "./components/Comparison";
import Limitations from "./components/Limitations";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </a>
  );
}

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <EntryGuide />
      <Features />
      <CategoryComics />
      <Comparison />
      <Limitations />
      <Faq />
      <About />
      <Contact />
      <Footer />
      <BackToTop />
    </main>
  );
}